import classNames from "classnames/dedupe";
import React, { useContext } from "react";

import { AccordionTitle, accordionContext } from ".";
import { SvgIcon } from "../../Icons";

function AccordionTitleWithIcon({ children }) {
  const context = useContext(accordionContext);
  return (
    <AccordionTitle classes={{ root: "filter-accordion-head" }}>
      <div className="filter-accordion-info">
        <div className="filter-accordion-info__title">{children}</div>
      </div>

      <div className="filter-accordion-status">
        <SvgIcon
          icon="FilterPlusIcon"
          classes={{
            root: classNames("icon-container icon-plus svg-fill filter-icon", {
              "filter-icon--active": context.expanded,
            }),
          }}
        />
      </div>
    </AccordionTitle>
  );
}

export default AccordionTitleWithIcon;
